import React, { useContext, useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { AuthContext } from '../context/AuthContext';
import { FiscalYearContext } from '../context/FiscalYearContext';
import {
    formatFiscalYear,
    formatFiscalYearRange,
    getCurrentFiscalYearStart
} from '../utils/fiscalYear';
import '../styles/Settings.css';

export default function Settings() {
    const { user } = useContext(AuthContext);
    const { fiscalYear, setFiscalYear } = useContext(FiscalYearContext);

    const fiscalYears = useMemo(() => {
        const current = getCurrentFiscalYearStart();
        const years: number[] = [];
        for (let year = current; year >= 2024; year -= 1) years.push(year);
        if (!years.includes(fiscalYear)) years.push(fiscalYear);
        return years.sort((a, b) => b - a);
    }, [fiscalYear]);

    if (!user) return <Navigate to="/" replace />;
    if (user.role !== 'superadmin') return <Navigate to="/dashboard" replace />;

    return (
        <div className="settings-page">
            <Sidebar />
            <main className="settings-content">
                <div className="settings-header">
                    <h1>Settings</h1>
                    <p>Choose the financial period used across the app.</p>
                </div>

                <section className="settings-card" aria-labelledby="fiscal-year-heading">
                    <div className="settings-card-copy">
                        <h2 id="fiscal-year-heading">Fiscal year</h2>
                        <p>
                            Switching fiscal years changes payment and expense records, along with
                            finance totals calculated from them. Students, courses, and other records
                            are not affected.
                        </p>
                    </div>

                    <label className="fiscal-year-field">
                        <span>Selected fiscal year</span>
                        <select
                            value={fiscalYear}
                            onChange={event => setFiscalYear(Number(event.target.value))}
                        >
                            {fiscalYears.map(year => (
                                <option key={year} value={year}>{formatFiscalYear(year)}</option>
                            ))}
                        </select>
                    </label>

                    <div className="fiscal-year-summary" role="status">
                        <strong>{formatFiscalYear(fiscalYear)}</strong>
                        <span>{formatFiscalYearRange(fiscalYear)}</span>
                    </div>

                    <p className="settings-saved-note">Your selection is saved automatically on this device.</p>
                </section>
            </main>
        </div>
    );
}
